import { trans } from '@lingoda/i18n';
import type { Currency } from '@lingoda/monolith-graphql';
import { Select } from '@lingoda/ui';
import type { SelectProps } from '@lingoda/ui';
import { usePaymentCurrencies } from '@lingoda/payments';
import { FilterGroup } from './FilterGroup';
import type { FilterProps } from '../../types';

interface CurrencyFilterProps extends FilterProps {
    currency: Currency;
}

export const CurrencyFilter = ({ currency, onFilterUpdate }: CurrencyFilterProps) => {
    const handleChange: SelectProps['onChange'] = (event) =>
        onFilterUpdate('currency', event.target.value as Currency);

    const { currencies, loading, error } = usePaymentCurrencies();

    if (loading || error || !currencies) {
        return null;
    }

    return (
        <FilterGroup id="currency-filter" label={trans('currency', {}, 'student-store')}>
            <Select
                value={currency}
                onChange={handleChange}
                options={currencies}
                getOptionValue={(currency) => currency}
                getOptionLabel={(currency) => currency}
            />
        </FilterGroup>
    );
};
